import React from 'react'

const ReportsFoodIcon = (
  <>
    <path
      d="M8.49987 5.83304C8.38936 5.83304 8.28338 5.78914 8.20524 5.711C8.1271 5.63286 8.0832 5.52688 8.0832 5.41637C8.0832 3.98262 7.0832 2.13429 5.46362 1.64887C5.35775 1.61715 5.26882 1.54468 5.21639 1.4474C5.16396 1.35011 5.15232 1.23599 5.18403 1.13012C5.21575 1.02425 5.28822 0.935323 5.3855 0.882891C5.48279 0.830459 5.59692 0.818821 5.70278 0.850536C7.68778 1.44637 8.91653 3.68429 8.91653 5.41637C8.91653 5.52688 8.87263 5.63286 8.79449 5.711C8.71635 5.78914 8.61037 5.83304 8.49987 5.83304Z"
      fill="#A67C52"
    />
    <path
      d="M10.6343 19.1671C10.1836 19.1585 9.73418 19.1154 9.29009 19.0379C9.02857 18.9904 8.76403 18.9615 8.49843 18.9512C8.23283 18.9615 7.96828 18.9904 7.70676 19.0379C6.24009 19.26 4.02468 19.5954 1.89843 16.1967C-0.698239 12.0421 -0.153656 7.2504 1.96176 5.54665C3.55968 4.26124 5.29009 4.54957 6.81801 4.80249C7.37264 4.9116 7.93515 4.97597 8.50009 4.99499C9.06504 4.97597 9.62754 4.9116 10.1822 4.80249C11.7105 4.54915 13.4405 4.26082 15.0384 5.54665C17.1538 7.24832 17.6984 12.0408 15.0984 16.1979C13.5497 18.6737 11.9538 19.1671 10.6343 19.1671Z"
      fill="#E86C60"
    />
    <path
      d="M12.6667 0V0.833333C12.6667 1.60688 12.3594 2.34875 11.8124 2.89573C11.2654 3.44271 10.5235 3.75 9.75 3.75V2.91667C9.75 2.14312 10.0573 1.40125 10.6043 0.854272C11.1513 0.307291 11.8931 0 12.6667 0Z"
      fill="#72C472"
    />
  </>
)

export default ReportsFoodIcon
